/**
 * Knopf „In OpenTable eintragen“ — Typen der API-Antwort (`GET /api/events/:id/opentable`) und der
 * Text für „Gastdaten kopieren“. Die REGELN (wann welcher Knopf erscheint) stehen auf dem Server
 * (`apps/api/src/lib/opentable.ts`); die Oberfläche zeigt nur an, was dort entschieden wurde.
 */
export interface OpentableTermin {
  datum: string;
  zeit: string;
  gaeste: number;
}

export interface OpentableEingetragen {
  am: string;
  von: string | null;
  termine: OpentableTermin[];
}

export interface OpentableKnopf {
  datum: string | null;
  zeit: string | null;
  gaeste: number | null;
  zustand: "bereit" | "ausgegraut" | "zu_gross";
  link: string | null;
  hinweis: string | null;
  fehlt: string[];
}

export type OpentableSicht =
  | { sichtbar: false; grund: string; eingetragen: OpentableEingetragen | null }
  | { sichtbar: true; knoepfe: OpentableKnopf[]; markierbar: boolean; eingetragen: OpentableEingetragen | null; geaendertSeitEintrag: boolean };

/** Die Angaben, die „Gastdaten kopieren“ in die Zwischenablage legt. */
export interface GastdatenEingabe {
  name?: string | null;
  firma?: string | null;
  email?: string | null;
  telefon?: string | null;
  anlass?: string | null;
  anmerkung?: string | null;
}

const ANMERKUNG_MAX = 500;

/** Leere Felder fallen weg; die Anmerkung wird einzeilig und auf 500 Zeichen gekürzt. */
export function gastdatenText(g: GastdatenEingabe): string {
  const sauber = (s: string | null | undefined) => (s ?? "").replace(/\s+/g, " ").trim();
  let anmerkung = sauber(g.anmerkung);
  if (anmerkung.length > ANMERKUNG_MAX) anmerkung = `${anmerkung.slice(0, ANMERKUNG_MAX - 1).trimEnd()}…`;
  const zeilen: [string, string][] = [
    ["Name", sauber(g.name)],
    ["Firma", sauber(g.firma)],
    ["E-Mail", sauber(g.email)],
    ["Telefon", sauber(g.telefon)],
    ["Anlass", sauber(g.anlass)],
    ["Anmerkung", anmerkung],
  ];
  return zeilen.filter(([, w]) => w !== "").map(([k, w]) => `${k}: ${w}`).join("\n");
}

/** „24.12.2026“ aus „2026-12-24“. */
export function datumDe(d: string | null | undefined): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(d ?? "");
  return m ? `${m[3]}.${m[2]}.${m[1]}` : "";
}
